var _rect, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 48.2 48.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 24.1,
    x2: 48.2,
    y2: 24.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#0D62CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#0955B1"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id0)",
    width: 48.2,
    height: 48.2,
    rx: 5.72,
    ry: 5.82
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#004DAB",
    cx: 24.1,
    cy: 24.37,
    r: 20.02
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#00CA72",
    cx: 24.1,
    cy: 24.37,
    r: 15.93
  })), /*#__PURE__*/React.createElement("text", {
    x: 15.72,
    y: 23.04,
    fill: "#FEFEFE",
    style: {
      fontWeight: 900,
      fontSize: "10.27px",
      fontFamily: "Arial"
    }
  }, "WE"), /*#__PURE__*/React.createElement("text", {
    x: 15.58,
    y: 34,
    fill: "#FEFEFE",
    style: {
      fontWeight: 500,
      fontSize: "13.78px",
      fontFamily: "Arial"
    }
  }, "RE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.27e7b53e2107ddf067db81b584164bb8.svg";
export { ForwardRef as ReactComponent };